import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
	Button,
	Modal,
	ModalBody,
	Col,
	Row,
	Container,
	ModalHeader,
	ModalFooter,
	ListGroup,
	ListGroupItem,
	ListGroupItemHeading,
	ListGroupItemText,
} from 'reactstrap';

import './EmissoesErro.scss';

class EmissoesErro extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isOpen: false,
		};
	}

	toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

	render() {
		const {
			value: { strCodigoErro, strErro },
		} = this.props;

		return (
			<Modal
				size="lg"
				id="modal-emissoes-erro"
				centered={true}
				isOpen={this.state.isOpen}
				onClosed={this.props.onClosed}
				backdrop="static">
				<ModalHeader className="bg-danger">
					<p>Lote recusado</p>
				</ModalHeader>
				<ModalBody>
					<ListGroup>
						<ListGroupItem>
							<ListGroupItemHeading>Código do Erro</ListGroupItemHeading>
							<ListGroupItemText>{strCodigoErro}</ListGroupItemText>
						</ListGroupItem>
						<ListGroupItem>
							<ListGroupItemHeading>Descrição do Erro</ListGroupItemHeading>
							<ListGroupItemText>{strErro}</ListGroupItemText>
						</ListGroupItem>
					</ListGroup>
				</ModalBody>
				<ModalFooter>
					<Container>
						<Row>
							<Col className="alert alert-danger">
								<strong>Obs: </strong>Caso necessite de suporte técnico referente a esta guia rejeitada, ressaltamos a necessidade de anexar o xml do documento fiscal em questão.
							</Col>
						</Row>
						<Row className="justify-content-around">
							<Col xs="auto">
								<Button color="info" onClick={() => this.closeModal()}>
									Fechar
								</Button>
							</Col>
						</Row>
					</Container>
				</ModalFooter>
			</Modal>
		);
	}
}

EmissoesErro.propTypes = {
	value: PropTypes.object,
	onClosed: PropTypes.func,
};

export default EmissoesErro;
